<template>
	<div class="flex flex-col p-8">
		<div class="flex w-full gap-4">
			<div class="flex flex-col w-[25%] gap-2">
				<MultiSelect
					v-model="fazendasEscolhidas"
					:label="$t('farm')"
					:options="fazendas"
				/>
			</div>

			<div class="flex flex-col w-[25%] gap-2">
				<DatePickerRange
					v-model="dateRange"
					:label="$t('exportRange')"
					:locale="localeDoSistema"
				/>
			</div>
		</div>

		<p class="mt-6 text-sm text-gray-600 flex items-start gap-2">
			<i
				class="fas fa-info-circle"
				style="margin-top: 2px"
			/>
			<span>{{ $t('climateDataSourceInfo') }}</span>
		</p>

		<Button
			style="margin-left: auto !important; margin-right: 20px !important"
			:label="$t('export')"
			color="trv-default"
			semantic-class="tiny"
			width-auto
			:disabled="!podeExportar"
			@click="exportar"
		/>
	</div>
</template>

<script>
import Button from '../../../components/Button/Button'
import DatePickerRange from '../../../components/DatePickerRange/DatePickerRange.vue'
import MultiSelect from '../../../components/MultiSelect/MultiSelect'
import moment from 'moment'

import {
	getDadosClimaticosCsv,
	getDropdown,
} from '../../../services/requests/ExportacaoRequests.js'

export default {
	components: {
		Button,
		DatePickerRange,
		MultiSelect,
	},
	data() {
		return {
			dropdown: [],
			fazendasEscolhidas: [],
			dateRange: null,
			exportando: false,
		}
	},
	computed: {
		fazendas() {
			return this.dropdown.map((m) => {
				return Object.assign(m, { label: m.fazenda, value: m.fazendaId })
			})
		},
		podeExportar() {
			return (
				!this.exportando &&
				this.fazendasEscolhidas.length > 0 &&
				this.dateRange != null &&
				this.dateRange.start != null &&
				this.dateRange.end != null
			)
		},
		localeDoSistema() {
			const idioma = this.$i18n.locale
			if (idioma === 'pt') return 'pt-BR'
			if (idioma === 'es') return 'es'
			return 'en'
		},
	},
	async created() {
		const response = await getDropdown()
		this.dropdown = response.data.result
	},
	methods: {
		async exportar() {
			if (!this.podeExportar) return

			this.exportando = true

			const startTimestamp = this.dateRange.start.getTime()
			const endTimestamp = this.dateRange.end.getTime()
			const periodo = `${moment(this.dateRange.start).format('YYYYMMDD')}_${moment(this.dateRange.end).format('YYYYMMDD')}`

			const fazendasSemDados = []
			const fazendasComErro = []

			const fazendas = this.fazendas.filter((f) => this.fazendasEscolhidas.includes(f.fazendaId))

			//Uma fazenda sem dados (404) não impede a exportação das demais
			for (const fazenda of fazendas) {
				try {
					const response = await getDadosClimaticosCsv({
						farmId: fazenda.fazendaId,
						startTimestamp,
						endTimestamp,
					})

					this.baixarArquivo(response.data, `dados-climaticos_${fazenda.fazenda}_${periodo}.csv`)
				} catch (error) {
					if (error.response && error.response.status === 404) {
						fazendasSemDados.push(fazenda.fazenda)
					} else {
						console.error('Erro ao exportar dados climáticos:', error)
						fazendasComErro.push(fazenda.fazenda)
					}
				}
			}

			if (fazendasSemDados.length > 0) {
				this.$store.commit('moduleMessages/mutationShowMessage', {
					messageTitle: this.$t('climateData'),
					messageText: this.$t('climateDataNoDataFarms', { farms: fazendasSemDados.join(', ') }),
					messageType: 'warning',
				})
			}

			if (fazendasComErro.length > 0) {
				this.$store.commit('moduleMessages/mutationShowMessage', {
					messageTitle: this.$t('climateData'),
					messageText: this.$t('climateDataExportError'),
					messageType: 'error',
				})
			}

			this.exportando = false
		},
		baixarArquivo(blobData, nomeArquivo) {
			const url = window.URL.createObjectURL(new Blob([blobData], { type: 'text/csv' }))
			const a = document.createElement('a')
			a.href = url
			a.download = nomeArquivo
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
			window.URL.revokeObjectURL(url)
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>
